import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { getAllStories as _getAllStories, getStories as _getStories, getStoryBySlug as _getStoryBySlug } from "@cinch-nx/data-storyblok";
import { dashify } from "@cinch-labs/shared-util";
import { traceFunction, tagError, setTag } from "@core/datadog-server";
var getAllStories = traceFunction("getAllStories", _getAllStories);
var getStories = traceFunction("getStories", _getStories);
var getStoryBySlug = traceFunction("getStoryBySlug", _getStoryBySlug);
export function getStaticProps(_) {
    return _getStaticProps.apply(this, arguments);
}
function _getStaticProps() {
    _getStaticProps = _async_to_generator(function(param) {
        var params, _preview, preview, page, make, model, version, resultsPerPage, destination, ref, story, ref1, reviews, numberOfReviews, makeOptions, modelOptions, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = param.params, _preview = param.preview, preview = _preview === void 0 ? false : _preview;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    page = 1;
                    version = preview ? "draft" : "published";
                    resultsPerPage = 10;
                    setTag("request.method", "GET");
                    setTag("request.params", params);
                    if (hasMakeParam(params)) {
                        setTag("request.params.make", params.make);
                        make = params === null || params === void 0 ? void 0 : params.make;
                        console.log("Make is set to", make);
                    }
                    if (make === "undefined") {
                        setTag("request.params.make", "undefined");
                        return [
                            2,
                            {
                                redirect: {
                                    destination: "/reviews/",
                                    permanent: true
                                }
                            }
                        ];
                    }
                    if (hasModelParam(params)) {
                        setTag("request.params.model", params.model);
                        model = params === null || params === void 0 ? void 0 : params.model;
                    }
                    if (model === "undefined") {
                        setTag("request.params.model", "undefined");
                        return [
                            2,
                            {
                                redirect: {
                                    destination: "/reviews/".concat(make),
                                    permanent: true
                                }
                            }
                        ];
                    }
                    if (hasPageParam(params)) {
                        setTag("request.params.page", params.page);
                        page = Number(params === null || params === void 0 ? void 0 : params.page);
                        destination = "/reviews";
                        if (make && model) {
                            destination = "".concat(destination, "/").concat(make, "/").concat(model);
                        }
                        if (make && !model) {
                            destination = "".concat(destination, "/").concat(make);
                        }
                        if (page === 1) {
                            return [
                                2,
                                {
                                    redirect: {
                                        destination: destination,
                                        permanent: true
                                    }
                                }
                            ];
                        }
                    }
                    return [
                        4,
                        Promise.all([
                            getStory({
                                version: version
                            }),
                            getReviews({
                                page: page,
                                perPage: 10,
                                version: version,
                                make: make,
                                model: model
                            }),
                            getMakeOptions(version),
                            getModelOptions(make, version)
                        ])
                    ];
                case 2:
                    ref = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        4
                    ]), story = ref[0], ref1 = ref[1], reviews = ref1.reviews, numberOfReviews = ref1.total, makeOptions = ref[2], modelOptions = ref[3];
                    return [
                        2,
                        {
                            props: {
                                isISR: true,
                                preview: preview,
                                story: story,
                                currentPage: page,
                                numberOfReviews: numberOfReviews,
                                selectedMake: make !== null && make !== void 0 ? make : null,
                                selectedModel: model !== null && model !== void 0 ? model : null,
                                makeOptions: makeOptions,
                                modelOptions: modelOptions,
                                resultsPerPage: resultsPerPage,
                                reviews: reviews,
                                layoutProps: {
                                    showBorderRadius: true
                                },
                                generatedAt: Date.now()
                            },
                            revalidate: 60
                        }
                    ];
                case 3:
                    error = _state.sent();
                    console.log(error);
                    if (_instanceof(error, Error) || typeof error === "string") {
                        setTag("response.statusCode", 404);
                        tagError(error);
                    }
                    return [
                        2,
                        {
                            notFound: true,
                            revalidate: 10
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _getStaticProps.apply(this, arguments);
}
function hasPageParam(params) {
    return typeof (params === null || params === void 0 ? void 0 : params.page) === "string";
}
function hasMakeParam(params) {
    return typeof (params === null || params === void 0 ? void 0 : params.make) === "string";
}
function hasModelParam(params) {
    return typeof (params === null || params === void 0 ? void 0 : params.model) === "string";
}
function getStory(_) {
    return _getStory.apply(this, arguments);
}
function _getStory() {
    _getStory = _async_to_generator(function(param) {
        var version, storyArgs, story;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    version = param.version;
                    storyArgs = {
                        version: version
                    };
                    if (version === "draft") {
                        storyArgs.cv = Date.now();
                    }
                    return [
                        4,
                        getStoryBySlug("car-review-hub", storyArgs)
                    ];
                case 1:
                    story = _state.sent();
                    if (!story || !story.content || story.content.component !== "ReviewHubPage") {
                        throw new Error("Failed to load story for 'car-review-hub' received: \"".concat(JSON.stringify(story, null, 4), '"'));
                    }
                    return [
                        2,
                        story
                    ];
            }
        });
    });
    return _getStory.apply(this, arguments);
}
function getModelOptions(make, version) {
    return _getModelOptions.apply(this, arguments);
}
function _getModelOptions() {
    _getModelOptions = _async_to_generator(function(make, version) {
        var storyArgs, stories, tags, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (!make) {
                        return [
                            2,
                            []
                        ];
                    }
                    storyArgs = {
                        version: version,
                        page: 1,
                        starts_with: "car-reviews-v2/".concat(dashify(make)),
                        per_page: 100
                    };
                    if (version === "draft") {
                        storyArgs.cv = Date.now();
                    }
                    return [
                        4,
                        getStories(storyArgs)
                    ];
                case 1:
                    stories = _state.sent().stories;
                    if (!stories) return [
                        2,
                        []
                    ];
                    tags = stories.map(function(story) {
                        return story.content.model;
                    }).sort();
                    if (!tags) return [
                        2,
                        []
                    ];
                    return [
                        2,
                        _to_consumable_array(new Set(tags))
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Error in getModelOptions: ".concat(error));
                    return [
                        2,
                        []
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getModelOptions.apply(this, arguments);
}
function getMakeOptions(version) {
    return _getMakeOptions.apply(this, arguments);
}
function _getMakeOptions() {
    _getMakeOptions = _async_to_generator(function(version) {
        var args, makes;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    args = {
                        starts_with: "car-reviews-v2/",
                        version: version,
                        sort_by: "content.make:asc"
                    };
                    if (version === "draft") {
                        args.cv = Date.now();
                    }
                    return [
                        4,
                        getAllStories(args)
                    ];
                case 1:
                    makes = _state.sent().stories.map(function(story) {
                        return story.content.make;
                    });
                    return [
                        2,
                        _to_consumable_array(new Set(makes))
                    ];
            }
        });
    });
    return _getMakeOptions.apply(this, arguments);
}
function getReviews() {
    return _getReviews.apply(this, arguments);
}
function _getReviews() {
    _getReviews = _async_to_generator(function() {
        var ref, _page, page, _perPage, perPage, _version, version, make, model, starts_with, reviewListArgs, reviewListData, reviews, error;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _page = ref.page, page = _page === void 0 ? 1 : _page, _perPage = ref.perPage, perPage = _perPage === void 0 ? 10 : _perPage, _version = ref.version, version = _version === void 0 ? "published" : _version, make = ref.make, model = ref.model;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    starts_with = "car-reviews-v2/";
                    if (make) {
                        starts_with = "car-reviews-v2/".concat(dashify(make));
                    }
                    if (make && model) {
                        starts_with = "car-reviews-v2/".concat(dashify(make), "/").concat(dashify(model));
                    }
                    reviewListArgs = {
                        version: version,
                        starts_with: starts_with,
                        page: page,
                        per_page: perPage,
                        sort_by: "published_at:desc"
                    };
                    if (version === "draft") {
                        reviewListArgs.cv = Date.now();
                    }
                    return [
                        4,
                        getStories(reviewListArgs)
                    ];
                case 2:
                    reviewListData = _state.sent();
                    reviews = reviewListData.stories.map(function(story) {
                        return toReview(story);
                    });
                    return [
                        2,
                        {
                            reviews: reviews,
                            total: reviewListData.total
                        }
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Error in getReviews: ".concat(error));
                    return [
                        2,
                        {
                            reviews: [],
                            total: 0
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _getReviews.apply(this, arguments);
}
export var formattedHref = function(url) {
    return url.replace(/car-reviews-v2/g, "/used-cars");
};
function toReview(input) {
    var ref, ref1, ref2;
    var ref3, _published_at, _snippet;
    return {
        path: formattedHref(input.full_slug),
        title: input.content.title,
        heroImage: (ref3 = (ref = input.content) === null || ref === void 0 ? void 0 : (ref1 = ref.gallery) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.image) !== null && ref3 !== void 0 ? ref3 : null,
        date: (_published_at = input.published_at) !== null && _published_at !== void 0 ? _published_at : "",
        make: input.content.make,
        model: input.content.model,
        starRating: input.content.starRating,
        id: input.uuid,
        snippet: (_snippet = input.content.snippet) !== null && _snippet !== void 0 ? _snippet : ""
    };
}
